// extracted by mini-css-extract-plugin
export default {"teaser":"LNfCxwF5","mobile":"mobile","image":"SIfykpZI","headline":"MXVrqaly","info":"S_uX4FnL","loader":"E1DdFFHs"};